/**
 * @type {boolean}
 * @summary Determine if the user is successfully authenticated
 */
export const isUserSignedIn = (state) => {
  return !!state.isAuthenticated;
};

/**
 * @type {object}
 * @summary Get the user's profile data
 */
export const userProfile = (state) => {
  const { agencyId, userType, initials } = state;
  return {
    agencyId,
    userType,
    initials
  };
};

/**
 * @type {string}
 * @param {string} locale The resource locale to pull from state
 * @summary Fetch specified resource endpoint
 */
export const resourceEndpoint = (state) => (locale) => state.resources[locale];
